module.exports = __webpack_public_path__ + "img/gf.c15aef1c.png";